import { Link } from "react-router-dom";

export function Header() {
  return (
    <header className="site-header">
      <div className="container">
        <Link
          to="/"
          className="brand"
          aria-label="ReleaseMachine home"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <span className="brand-mark" aria-hidden="true" />
          ReleaseMachine
        </Link>
        <nav className="site-nav" aria-label="Primary">
          <Link to="/#how-it-works">How it works</Link>
          <Link to="/#pricing">Pricing</Link>
          <Link to="/#faq">FAQ</Link>
          <Link to="/build" className="btn btn-primary">
            Build My Campaign
          </Link>
        </nav>
      </div>
    </header>
  );
}
